module.exports = __webpack_public_path__ + "static/media/css.5c4e16ce.png";